import Select from 'components/select';
import {lazyLoad} from 'methods/utils';
import KurortInfoPlate from 'components/kurort/kurortInfoPlate';

/**
 * Обработчик селектов
 */
export const initSelects = () => {
    window.sortSelect = new Select(document.querySelector('.Select[data-name="sort"]'));
    new Select(document.querySelector('.Select[data-name="geo"]'));
};

/**
 * Загрузка дополнительных объектов
 */
export const initLoadMoreObjects = () => {
    const $publicationList = document.querySelector('.js-publicationList');
    const $morePublications = document.querySelector('.js-morePublications');

    const observer = new IntersectionObserver((entries) => {
        entries.forEach((entry) => {
            if (entry.isIntersecting) {
                let $publicationItems = $publicationList.querySelectorAll('.js-publicationItem');
                let formData = new FormData(document.querySelector('.js-publicationForm'));

                $publicationItems.forEach($item => {
                    formData.append('exclude_list[]', $item.dataset.id);
                });

                setTimeout(() => {
                    appendObjects(formData);
                }, 500);
            }
        });
    });

    observer.observe($morePublications);
};

/**
 * Обработчики фильтров
 * @param callback [function]
 */
export const initFiltersPanel = (callback) => {
    const $filtersList = document.querySelector('.js-filtersList');
    const $filtersSelectedList  = document.querySelector('.js-filtersSelectedList');
    const $filtersSelectedReset = document.querySelector('.js-filtersSelectedReset');
    window.selectedFilters = [];

    // Выбор фильтра
    $filtersList.addEventListener('click', (event) => {
        let $filerItem = event.target;
        if ($filerItem.classList.contains('js-filterItem')) {
            $filerItem.classList.add('active');

            $filtersSelectedList.insertAdjacentElement('beforeend', $filerItem);
            if ($filtersSelectedList.children.length !== 0) {
                $filtersSelectedReset.disabled = false;

                if (callback) {
                    callback(false);
                }
            }

            window.selectedFilters.push($filerItem.dataset.id);

            fetchObjects();
        }
    });

    // Сброс фильтра
    $filtersSelectedList.addEventListener('click', (event) => {
        let $filerItem = event.target;
        if ($filerItem.classList.contains('js-filterReset')) {
            const $parent = $filerItem.closest('.js-filterItem');

            $parent.classList.remove('active');
            $filtersList.insertAdjacentElement('beforeend', $parent);

            if ($filtersSelectedList.children.length === 0) {
                $filtersSelectedReset.disabled = true;

                if (callback) {
                    callback(true);
                }
            }

            const index = window.selectedFilters.indexOf($parent.dataset.id);
            if (index > -1) {
                window.selectedFilters.splice(index, 1);
            }

            fetchObjects();
        }
    });

    // Сброс всех фильтров
    $filtersSelectedReset.addEventListener('click', (event) => {
        [...$filtersSelectedList.children].forEach((item) => {
            item.classList.remove('active');
            $filtersList.insertAdjacentElement('beforeend', item);
        });

        event.target.disabled = true;

        if (callback) {
            callback(true);
        }

        window.selectedFilters = [];

        fetchObjects();
    });
};

/**
 * Загрузка объектов с учетом фильтров
 */
export const fetchObjects = (e) => {
    const $publicationList          = document.querySelector('.js-publicationList');
    const $publicationForm          = document.querySelector('.js-publicationForm');
    const $filtersList              = document.querySelector('.js-filtersList');
    const $filtersSelectedList      = document.querySelector('.js-filtersSelectedList');
    const $filtersSelectedReset     = document.querySelector('.js-filtersSelectedReset');
    let formData                    = new FormData($publicationForm);

    if (e && e.target && e.target.getAttribute('name') === 'geo' && window.selectedFilters.length > 0) {
        document.querySelector('.js-filtersSelectedReset').click();
    }

    if (window.sortSelect) {
        formData.append('sort', window.sortSelect.getValue());
    }

    window.selectedFilters.forEach(item => {
        formData.append('tags[]', item);
    });

    fetch('/blog/fetch_objects/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        $publicationList.innerHTML = '';

        if (r.items) {
            $publicationList.insertAdjacentHTML('beforeend', r.items);
            lazyLoad($publicationList);
        }

        if (r.more_button) {
            $publicationList.insertAdjacentHTML('beforeend', r.more_button);

            initLoadMoreObjects();
        }

        if (r.tags) {
            $filtersList.innerHTML = r.tags;
        }

        if (r.selected_tags) {
            $filtersSelectedList.innerHTML = r.selected_tags;
            $filtersSelectedReset.removeAttribute('disabled');
        }
    });
};

/**
 * Загрузка объектов с учетом фильтров
 */
export const appendObjects = (formData) => {
    const $publicationList      = document.querySelector('.js-publicationList');
    const $morePublications     = document.querySelector('.js-morePublications');
    const $filtersSelectedList  = document.querySelector('.js-filtersSelectedList');

    if (window.sortSelect) {
        formData.append('sort', window.sortSelect.getValue());
    }

    window.selectedFilters.forEach(item => {
        formData.append('tags[]', item);
    });

    fetch('/blog/fetch_objects/', {
        method: 'POST',
        headers: {
            'X-Requested-With': 'XMLHttpRequest',
        },
        body: formData,
    })
    .then(response => response.json())
    .then(r => {
        $morePublications.remove();

        if (r.items) {
            $publicationList.insertAdjacentHTML('beforeend', r.items);
            lazyLoad($publicationList);
        }

        if (r.more_button) {
            $publicationList.insertAdjacentHTML('beforeend', r.more_button);

            initLoadMoreObjects();
        }
    });
};

/**
 * Загрузка объектов с учетом фильтров
 */
export const initEvents = (isMobile = false) => {
    const $publicationForm = document.querySelector('.js-publicationForm');

    $publicationForm.addEventListener('change', fetchObjects);
    $publicationForm.addEventListener('submit', (e) => {
        e.preventDefault();
        e.stopPropagation();
    });

    if (isMobile) {
        window.sortSelect.on('change', fetchObjects);
    }
};

/**
 * Вставка мини-баннера с поддержкой
 */
export const insertMiniSupportBlock = () => {
    const kurortInfoPlate = new KurortInfoPlate({
        container: '.js-publicationList',
    });

    const $plateSupport = kurortInfoPlate.create('miniSupport');
    const $publicationsList = document.querySelector('.js-publicationList');
    const $publicationItems = document.querySelectorAll('.js-publicationItem');

    if ($plateSupport && $publicationsList && $publicationItems.length) {
        $publicationsList.insertBefore($plateSupport, $publicationItems[3]);
    }
};
